"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var lodash_1 = __importDefault(require("lodash"));
var utils_1 = require("@qwilr/kaleidoscope/utils");
var CommentMarker_1 = __importDefault(require("../CommentMarker/CommentMarker"));
var PositioningUtils_1 = require("./PositioningUtils");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var ReactCSSTransitionGroup = require("react-addons-css-transition-group");
var CommentGroup = (function (_super) {
    __extends(CommentGroup, _super);
    function CommentGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.isWatchingResize = false;
        _this.renderOuterCommentThread = function () {
            var elem = (0, EditorTypes_1.isHTMLElement)(_this.props.containerElem) ? _this.props.containerElem : _this.props.containerElem.current;
            return react_dom_1.default.createPortal(react_1.default.createElement("div", { className: "comment-group__comment-container", ref: _this.threadRef },
                react_1.default.createElement(ReactCSSTransitionGroup, { component: react_1.default.Fragment, transitionName: "comment-group__transition", transitionEnterTimeout: 150, transitionLeaveTimeout: 150 }, _this.isMounted && _this.props.isShowing && (react_1.default.createElement("div", { key: "comment-group__comment-container-inner", className: "comment-group__comment-container-inner" }, _this.props.children)))), elem);
        };
        _this.hideThread = function () {
            if (_this.props.isShowing) {
                _this.props.toggleShowing();
            }
        };
        _this.setThreadPosition = function () {
            if (!_this.markerRef.current || !_this.threadRef.current) {
                return;
            }
            var containerElem = _this.props.containerElem;
            var container = (0, EditorTypes_1.isHTMLElement)(containerElem)
                ? containerElem.getBoundingClientRect()
                : containerElem.current.getBoundingClientRect();
            var markerRect = _this.markerRef.current.getBoundingClientRect();
            var browserViewport = window.innerWidth || document.documentElement.clientWidth;
            var threadRect = _this.threadRef.current.getBoundingClientRect();
            var threadWillOverflowViewport = (0, PositioningUtils_1.getThreadWillOverflowViewport)(markerRect, threadRect, browserViewport);
            if (threadWillOverflowViewport) {
                var _a = (0, PositioningUtils_1.getPositionsForThreadWhenOverflowingViewport)(markerRect, container, browserViewport), rightPosition = _a.rightPosition, topPosition = _a.topPosition, leftPosition = _a.leftPosition;
                _this.threadRef.current.style.right = "".concat(rightPosition, "px");
                _this.threadRef.current.style.top = "".concat(topPosition, "px");
                _this.threadRef.current.style.left = leftPosition;
            }
            else {
                var inViewportPositions = (0, PositioningUtils_1.getPositionsForThreadWhenInViewport)(container, markerRect);
                _this.threadRef.current.style.top = "".concat(inViewportPositions.topPosition, "px");
                _this.threadRef.current.style.left = "".concat(inViewportPositions.leftPosition, "px");
            }
        };
        _this.onWindowResize = function () {
            _this.setThreadPosition();
        };
        _this.isMounted = false;
        _this.markerRef = react_1.default.createRef();
        _this.threadRef = react_1.default.createRef();
        _this.onClickOutside = new utils_1.OnClickOutside([
            ".comment-group",
            ".comment-group__comment-container",
            ".modal-container",
        ], _this.hideThread);
        return _this;
    }
    CommentGroup.prototype.componentDidMount = function () {
        this.isMounted = true;
        this.setThreadPosition();
        if (this.props.isShowing && this.markerRef.current) {
            (0, PositioningUtils_1.makeVisibleInViewport)(this.markerRef.current);
        }
    };
    CommentGroup.prototype.componentDidUpdate = function () {
        if (this.props.isShowing) {
            this.onClickOutside.startListening();
        }
        else {
            this.onClickOutside.stopListening();
        }
        if (this.props.isShowing && !this.isWatchingResize) {
            this.throttledWindowResize = lodash_1.default.throttle(this.onWindowResize, 500);
            this.isWatchingResize = true;
            window.addEventListener("resize", this.throttledWindowResize);
            this.setThreadPosition();
        }
        else if (!this.props.isShowing && this.isWatchingResize) {
            this.isWatchingResize = false;
            window.removeEventListener("resize", this.throttledWindowResize);
        }
    };
    CommentGroup.prototype.componentWillUnmount = function () {
        if (this.isWatchingResize) {
            window.removeEventListener("resize", this.throttledWindowResize);
        }
    };
    CommentGroup.prototype.render = function () {
        var _a = this.props, isRead = _a.isRead, isResolved = _a.isResolved, isShowing = _a.isShowing, toggleShowing = _a.toggleShowing;
        return (react_1.default.createElement("div", { className: "comment-group", ref: this.markerRef },
            react_1.default.createElement(CommentMarker_1.default, { read: isRead, selected: isShowing, resolved: isResolved, onClick: toggleShowing }),
            this.renderOuterCommentThread()));
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], CommentGroup.prototype, "isMounted", void 0);
    CommentGroup = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], CommentGroup);
    return CommentGroup;
}(react_1.default.Component));
exports.default = CommentGroup;
